// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "An embeddable, configurable means of visualising the spread of crime across a jurisdiction's postcodes.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Crime postcode map",
  id: "crime-postcode-map",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Crime", "Data viz", "Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/crime-postcode-map/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "CrimePostcodeMapConfigTool" */ "app/components/tools/CrimePostcodeMapConfigTool/CrimePostcodeMapConfigTool"),
    loading: DynamicImportLoader,
    modules: ["CrimePostcodeMapConfigTool"]
  })
};

export default CONFIG;
